import { Pill, Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { IconButton } from "@src/appV2/redesign/components/IconButton";

import goldCoinImage from "./assets/images/goldCoin.png";
import { GUARANTEED_PAY_BANNER_GRADIENT } from "./constants";

interface GuaranteedPayPricingSurveyBannerProps {
  onClick: () => void;
  onDismiss: () => void;
}

export function GuaranteedPayPricingSurveyBanner(props: GuaranteedPayPricingSurveyBannerProps) {
  const { onClick, onDismiss } = props;

  return (
    // Box wrapper needed for banner to stretch to full height of sibling banners
    <Box>
      <Stack
        sx={(theme) => ({
          padding: theme.spacing(5),
          borderRadius: theme.borderRadius?.medium,
          background: GUARANTEED_PAY_BANNER_GRADIENT,
          height: "100%",
          position: "relative",
          overflow: "hidden",
        })}
      >
        <Box
          component="img"
          src={goldCoinImage}
          alt="Coin"
          sx={{
            position: "absolute",
            bottom: 0,
            right: 0,
            height: "92%",
            maxHeight: 180,
            aspectRatio: "1 / 1",
            objectFit: "contain",
            pointerEvents: "none",
            transform: "translate(20%, 18%)",
          }}
        />
        <IconButton
          aria-label="Dismiss"
          iconType="close"
          size="small"
          variant="ghost"
          sx={{
            position: "absolute",
            top: (theme) => theme.spacing(3),
            right: (theme) => theme.spacing(3),
            zIndex: 1,
          }}
          onClick={onDismiss}
        />
        <Pill
          label="Coming soon"
          size="small"
          sx={{ alignSelf: "flex-start", position: "relative" }}
        />
        <Stack
          gap={5}
          sx={{ flex: 1, justifyContent: "space-between", marginTop: 2, position: "relative" }}
        >
          <Stack gap={3}>
            <Text bold variant="h5">
              Guaranteed Pay
            </Text>
            <Text
              variant="body2"
              sx={{ color: (theme) => theme.palette.text.secondary, maxWidth: "70%" }}
            >
              Get paid even when a facility cancels on you last-minute.
            </Text>
          </Stack>
          <Button
            variant="contained"
            size="small"
            sx={{ alignSelf: "flex-start" }}
            onClick={onClick}
          >
            Join the waitlist
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}
